import { computed, defineComponent } from 'vue';
import styles from './index.module.scss';
import xssInstance from '@dts/shared/src/utils/xss';

const props = {
  text: {
    type: String,
    default: '',
  },
  patterns: {
    type: String,
    default: '',
  },
};

const Highlight = defineComponent({
  setup: (props, { slots }) => {
    const textWithHighlight = computed(() => {
      if (!props.text || !props.patterns) return props.text;

      const escapedPattern = props.patterns.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
      const originalString = new RegExp(escapedPattern, 'ig');

      return props.text.replace(originalString, (match) => {
        return `<span style="color: #0F5EF7">${match}</span>`;
      });
    });

    return () => (
      <div class={styles.highlight} v-html={xssInstance.process(textWithHighlight.value)}></div>
    );
  },
  props,
});
export default Highlight;
